import React from "react";
import { FormInput, Button, Loader } from "ui-kit-ck-consultant";
import { Link } from "react-router-dom";

import pilotagecabinetLogo from "../../images/pilotagereseau.svg";

import axiosConfig from "../../utils/axiosConfig";

export default class Forgot extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: false,
      email: this.props.location.state ? this.props.location.state.email : "",
      success: false,
    };
  }

  handleForgotClick = (event) => {
    this.setState(
      {
        isLoad: true,
      },
      () => {
        event.preventDefault();
        axiosConfig({
          url: "/auth/forgot",
          data: {
            email: this.state.email,
          },
        }).then((res) => {
          if (res.data.success === true) {
            this.setState({ success: true, isLoad: false });
          } else {
            this.setState({ isLoad: false }, () => {
              alert("Erreur lors du renvoi de mot de passe");
            });
          }
        });
      }
    );
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
      update: true,
    });
  };

  render() {
    return (
      <>
        <div>
          <img
            alt="logo"
            className="d-block ml-auto mr-auto mb-20"
            style={{ maxWidth: "100%" }}
            height="60"
            src={pilotagecabinetLogo}
          />
          <h4>Mot de passe oublié</h4>
          {this.state.success === false ? (
            <>
              <p className="mb-20">
                Saissiez votre adresse e-mail, un nouveau mot de passe vous sera
                envoyé
              </p>
              <FormInput
                className="mb-20"
                title="Adresse mail"
                type="email"
                name="email"
                value={this.state.email}
                onChange={this.handleInputChange}
              />
              <Button
                className="mb-20"
                text="Envoyer le nouveau mot de passe"
                onClick={this.handleForgotClick}
              />
            </>
          ) : (
            <p className="mb-20 text-center">
              Nous vous avons envoyé votre nouveau mot de passe à l'adresse{" "}
              <b>{this.state.email}</b>
            </p>
          )}
          <Link
            to={{
              pathname: "/signin",
              state: {
                email: this.state.email,
              },
            }}
          >
            Retour
          </Link>
        </div>
        <Loader show={this.state.isLoad} />
      </>
    );
  }
}
